import React from "react";
import styles from "./ComingSoonPage.module.css";
import { IMAGES } from "../utils/GetImages";

export default function ComingSoonPage() {
  const MainBackground = IMAGES["MainBackground.png"];

  return (
    <div
      className={styles["coming-soon-container"]}
      style={{
        background: `url(${MainBackground}) center center / cover no-repeat`,
      }}
    >
      <div className={styles["coming-soon-content"]}>
        <div className={styles["logo-section"]}>
          <img
            src="/icon.png"
            alt="Mahjong Icon"
            className={styles["mahjong-icon"]}
          />
          <h1 className={styles["main-title"]}>World Series of Mahjong</h1>
          <h2 className={styles["subtitle"]}>Australia</h2>
        </div>

        <div className={styles["message-section"]}>
          <div className={styles["clock-icon"]}>⏰</div>
          <h3 className={styles["coming-soon-title"]}>Coming Soon</h3>
          <p className={styles["coming-soon-message"]}>
            We're working hard to bring you an amazing experience. Stay tuned
            for updates!
          </p>
        </div>

        <div className={styles["social-section"]}>
          <p className={styles["social-text"]}>Follow us for updates:</p>
          <div className={styles["social-links"]}>
            <a
              href="https://www.youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["social-link"]}
            >
              <img
                src="/youtube.png"
                alt="YouTube"
                className={styles["social-icon"]}
              />
              YouTube
            </a>
            <a
              href="https://www.xiaohongshu.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["social-link"]}
            >
              <img
                src="/rednote.png"
                alt="小紅書"
                className={styles["social-icon"]}
              />
              小紅書
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles["social-link"]}
            >
              <img
                src="/ig.png"
                alt="Instagram"
                className={styles["social-icon"]}
              />
              Instagram
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
